import language from "#scripts/translation";

export const countdownFront = (countdownDate, title, link) => {
  const now = new Date();
  const [day, month, year] = countdownDate.split(".");
  const target = new Date(`${year}-${month}-${day}`);
  const diffTime = target - now;        // difference in milliseconds
  const daysToDate = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  const linkArray = link
    .replaceAll("&amp;", "&")
    .split(";")
    .map((x) => x.replace("}", "").split("{"));

  let countdownLinks = [];
  for (const item of linkArray) {
    // let icon = "";
    let target = "";
    if (item.length > 1 && item[1].includes("://")) {
      // icon = "open_in_new";
      target = "_blank";
    }
    const countdownLink = `
              <a class="countdown-link" href="${item[1]}" title="${language("NAV_OPEN_I_NEW")}" target="${target}" rel="noopener noreferrer">
                ${item[0]}
                </a>`;
                // <span class="material-icons-outlined notranslate buttonrow__button__icon">${icon}</span>
                countdownLinks.push(countdownLink);
              }
  const links = countdownLinks.join("");

  return `
        <div class="countdown" id="countdown__frontpage">
          <span class="countdown-days">${daysToDate}</span>
          <div class="countdown-text">
            <span class="countdown-title">${title}</span>
            ${links}
          </div>
        </div>`;
};
